export const brandOptions = [
  { id: 'ATS', name: 'ATS', fullName: 'Atlas' },
  { id: 'BGT', name: 'BGT', fullName: 'Bridgestone' },
  { id: 'CON', name: 'CON', fullName: 'Continental' },
  { id: 'GDY', name: 'GDY', fullName: 'Goodyear' },
  { id: 'HKK', name: 'HKK', fullName: 'Hankook' },
  { id: 'LLG', name: 'LLG', fullName: 'Ling Long' },
  { id: 'MCL', name: 'MCL', fullName: 'Michelin' },
  { id: 'NEX', name: 'NEX', fullName: 'Nexen' },
  { id: 'PRL', name: 'PRL', fullName: 'Pirelli' },
  { id: 'YKH', name: 'YKH', fullName: 'Yokohama' },

  // Singapore
  { id: 'GY', name: 'GY', fullName: 'Goodyear' },
  { id: 'NX', name: 'NX', fullName: 'Nexen' },
  { id: 'PI', name: 'PI', fullName: 'Pirelli' },
  { id: 'HK', name: 'HK', fullName: 'Hankook' },
  { id: 'BR', name: 'BR', fullName: 'Bridgestone' },
]

export const brandImages = {
  ATLAS: 'ATS',
  BGT: 'BGT',
  CON: 'CONT',
  GDY: 'GDY',
  HKK: 'HKK',
  LINGLONG: 'LLG',
  MCL: 'MCL',
  NEX: 'NEX',
  PRL: 'PRL',
  YKH: 'YKH',

  // Singapore
  BR: 'BGT',
  HK: 'HKK',
  PI: 'PRL',
  NX: 'NEX',
  GY: 'GDY',
}

export const getBrandOptions = (dealershipBrand) => {
  let options = []
  switch (dealershipBrand) {
    case 'bmw':
      options.push(...['BGT', 'CON', 'GDY', 'HKK', 'MCL', 'PRL', 'YKH'])
      break
    case 'mercedes':
      options.push(...['BGT', 'CON', 'GDY', 'HKK', 'PRL'])
      break
    case 'jlr':
      options.push(...['CON', 'GDY', 'MCL', 'PRL'])
      break
    case 'vw':
      options.push(...['BGT', 'GDY', 'HKK', 'NEX', 'PRL'])
      break
    case 'byd':
      options.push(...['NEX', 'GDY', 'CON', 'ATS', 'LLG', 'HKK'])
      break
    case 'vwsg':
      options.push(...['GY', 'BR', 'HK', 'PI', 'NX'])
      break
    default:
      options.push(...['BGT', 'GDY', 'HKK', 'PRL'])
      break
  }
  options = options.map((brand) => brandOptions.find((option) => option.id === brand))
  options.sort((a, b) => (a?.fullName < b?.fullName ? -1 : b?.fullName < a?.fullName ? 1 : 0))
  return options
}

export const getBrandsDict = (dealershipBrand) => {
  let dict = {}
  for (const option of getBrandOptions(dealershipBrand)) {
    dict[option.name] = option.fullName
  }
  return dict
}
